<template>
  <div v-html="row.content"></div>
</template>

<script>
import boardEdit from '@/app/board/js/boardEdit'
import boardMeta from './js/boardMeta'

export default {
  mixins: [boardEdit, boardMeta],
  components: {
    // MainContainer: () => import('@/component/container/MainContainer')
  }
}
</script>
